// extracted by mini-css-extract-plugin
module.exports = {"greyColor":"#d3d8dd","container":"MaterialDropdown_container__3b6Bc","label":"MaterialDropdown_label__2Swat","selectField":"MaterialDropdown_selectField__1eOk6"};